module.exports = __webpack_public_path__ + "000-core/assets/images/png/icon-link-actu.png";